/* FLAC upgrade hub. Loaded globally from theme.liquid (not from the section)
   because script tags inside SPA-swapped content never execute — the same
   reason od-resume-row.js is global. boot() derives its state from the DOM
   (an init flag on the section root), so it is safe to call repeatedly. */
(function () {
  "use strict";

  function boot() {
    var root = document.querySelector("[data-od-upgrade-hub]");
    if (!root || root.dataset.odUpInit === "1") return;
    root.dataset.odUpInit = "1";

    var hubEndpoint = root.dataset.hubEndpoint || "/apps/library/upgrade-hub";
    var loggedIn = root.dataset.loggedIn === "true";
    var contactUrl = root.dataset.contactUrl || "/pages/contact";

    var statusEl = root.querySelector("[data-od-up-status]");
    var toolbarEl = root.querySelector("[data-od-up-toolbar]");
    var countEl = root.querySelector("[data-od-up-count]");
    var cartLink = root.querySelector("[data-od-up-cart]");
    var cartCountEl = root.querySelector("[data-od-up-cart-count]");
    var itemsEl = root.querySelector("[data-od-up-items]");
    var emptyTemplate = root.querySelector("[data-od-up-empty]");
    var loginTemplate = root.querySelector("[data-od-up-login]");

    var addedCount = 0;

    function setStatus(html) {
      if (!statusEl) return;
      statusEl.hidden = false;
      statusEl.innerHTML = html;
    }

    function hideStatus() {
      if (statusEl) statusEl.hidden = true;
    }

    function showTemplate(template) {
      hideStatus();
      if (template && itemsEl) {
        itemsEl.hidden = false;
        itemsEl.innerHTML = "";
        itemsEl.appendChild(template.content.cloneNode(true));
      }
    }

    function escapeText(value) {
      var div = document.createElement("div");
      div.textContent = value == null ? "" : String(value);
      return div.innerHTML;
    }

    function formatPrice(price) {
      var amount = Number(price);
      if (!isFinite(amount)) return "";
      return "$" + amount.toFixed(2);
    }

    function renderItem(item) {
      var titleParts = String(item.title || "").split(" - ");
      var work = escapeText(titleParts[0]);
      var cast = titleParts.length > 1 ? escapeText(titleParts.slice(1).join(" - ")) : "";
      var art = item.imageUrl
        ? '<img class="od-up-item__art" src="' + escapeText(item.imageUrl) + '" alt="" loading="lazy">'
        : '<span class="od-up-item__art od-up-item__art--empty"></span>';
      var productLink = item.handle ? "/products/" + encodeURIComponent(item.handle) : null;
      var title =
        '<span class="od-up-item__work">' + work + "</span>" +
        (cast ? '<br><span class="od-up-item__cast">' + cast + "</span>" : "");
      if (productLink) {
        title = '<a class="od-up-item__link" href="' + productLink + '">' + title + "</a>";
      }

      return (
        '<div class="od-up-item" data-od-up-item="' + escapeText(item.variantId) + '">' +
        art +
        '<div class="od-up-item__info">' +
        '<span class="od-up-item__title">' + title + "</span>" +
        '<span class="od-up-item__badge">MP3 owned &middot; FLAC upgrade ' + formatPrice(item.price) + "</span>" +
        "</div>" +
        '<div class="od-up-item__action">' +
        '<button class="od-up-btn" type="button" data-od-up-add data-variant-id="' +
        escapeText(item.variantId) + '">Upgrade &middot; ' + formatPrice(item.price) + "</button>" +
        "</div>" +
        "</div>"
      );
    }

    function renderItems(result) {
      hideStatus();
      if (!itemsEl) return;

      if (!result.items || result.items.length === 0) {
        showTemplate(emptyTemplate);
        return;
      }

      if (toolbarEl) {
        toolbarEl.hidden = false;
        if (countEl) {
          var count = result.items.length;
          countEl.textContent =
            count + (count === 1 ? " album" : " albums") + " ready to upgrade";
        }
      }

      itemsEl.hidden = false;
      itemsEl.innerHTML = result.items.map(renderItem).join("");
    }

    function updateCartLink() {
      if (!cartLink) return;
      cartLink.hidden = addedCount === 0;
      if (cartCountEl) cartCountEl.textContent = String(addedCount);
    }

    function handleAddClick(event) {
      var button = event.target.closest("[data-od-up-add]");
      if (!button) return;

      var variantId = Number(button.dataset.variantId);
      if (!variantId) return;

      button.disabled = true;
      button.textContent = "Adding…";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error("cart_add_failed");
          return response.json();
        })
        .then(function () {
          addedCount += 1;
          updateCartLink();
          button.textContent = "In cart ✓";
          button.classList.add("od-up-btn--added");
          document.dispatchEvent(new CustomEvent("od:cart:added"));
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = "Try again";
        });
    }

    function load() {
      fetch(hubEndpoint, { headers: { Accept: "application/json" } })
        .then(function (response) { return response.json(); })
        .then(function (result) {
          if (result && result.ok) {
            renderItems(result);
          } else {
            setStatus(
              "<p>We couldn't check your collection just now. Please try again shortly or " +
                '<a href="' + contactUrl + '">contact us</a>.</p>'
            );
          }
        })
        .catch(function () {
          setStatus("<p>We couldn't check your collection. Please try again shortly.</p>");
        });
    }

    root.addEventListener("click", handleAddClick);

    if (loggedIn) {
      load();
    } else {
      showTemplate(loginTemplate);
    }
  }

  var bootScheduled = false;
  function scheduleBoot() {
    if (bootScheduled) return;
    bootScheduled = true;
    window.requestAnimationFrame(function () {
      bootScheduled = false;
      boot();
    });
  }

  if (!window.__odUpgradeHubWired) {
    window.__odUpgradeHubWired = true;

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }

    [
      "od:after-swap",
      "od:main-content-replaced",
      "shopify:section:load",
      "turbo:load",
      "turbolinks:load",
      "pjax:complete",
      "swup:contentReplaced",
      "barba:after"
    ].forEach(function (eventName) {
      document.addEventListener(eventName, scheduleBoot);
    });

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes.length > 0) {
          scheduleBoot();
          return;
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } else {
    boot();
  }
})();
